var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-app"},[_c('recruitment-header-section'),_c('recruitment-sidebar-vue'),_c('div',{attrs:{"id":"maincontent"}},[_c('router-view')],1),_c('footer-section-vue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }